import { Link } from 'react-router';
import { Icon } from '../../components/Icon';

/**
 * Miesto, ktoré si dostupnosť drží na prehľade a v detaile stránky (ticket 12).
 * Vlastné meranie pripravované vo v2 — nie napojenie na cudziu službu.
 */
export function UptimeSoonCard({ compact = false }: { compact?: boolean }) {
  return (
    <section className="card soon flex flex-col gap-4 px-[22px] py-5" aria-label="Dostupnosť — pripravuje sa">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <Icon name="pulse" size={16} className="text-faint" />
          <span className="card-t">Dostupnosť {compact ? '' : 'stránok'}</span>
          <span className="pill bg-raised text-faint">pripravuje sa vo v2</span>
        </div>
        <Link to="/uptime" className="btn btn-g h-[30px] text-xs">Čo sa plánuje →</Link>
      </div>
      <p className="hint m-0 max-w-[62ch]">
        {compact
          ? 'Tu bude 60-dňový pruh dostupnosti tejto stránky — vlastné meranie, nie napojenie na cudziu službu.'
          : 'Tu bude prehľad dostupnosti všetkých stránok — vlastné meranie, nie napojenie na cudziu službu. Zatiaľ je to len miesto, ktoré si funkcia drží.'}
      </p>
    </section>
  );
}
